<template>
	<v-dialog persistent width="auto" v-model="showDialog" v-if="selectedItem">
		<v-card style="min-height: 50vh; max-height: 80vh; width: 33vw; min-width: 400px" class="d-flex flex-column">
			<v-card-title class="card-header text-left fixed-card-title2">
				<v-row no-gutters>
					<v-col class="align-center d-flex" cols="10">
						<v-toolbar-title>{{ $t('item') }} {{ $t('details') }}</v-toolbar-title>
					</v-col>
					<v-spacer />
					<v-icon @click="$emit('closeDialog')" class="white-icon">mdi-close</v-icon>
				</v-row>
			</v-card-title>
			<v-card-text class="pa-4 flex-grow-1 d-flex flex-column overflow-y-auto">
				<div class="flex-grow-1">
					<v-row dense class="ma-0">
						<v-col cols="8" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('item-model-name') }}:</div>
							<div class="text-body-1">{{ selectedItem.itemModel.name }}</div>
						</v-col>
						<v-col cols="4" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('serial-number') }}:</div>
							<div class="text-body-1">{{ selectedItem.serialNumber || '-' }}</div>
						</v-col>
						<v-col cols="8" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('manufacturer') }}:</div>
							<div class="text-body-1">{{ selectedItem.itemModel.manufacturer }}</div>
						</v-col>
						<v-col cols="4" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('remote-connect-id') }}:</div>
							<div class="text-body-1">{{ selectedItem.remoteConnectIdString || '-' }}</div>
						</v-col>
						<v-col cols="8" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('organization-name') }}:</div>
							<div class="text-body-1" :style="{ color: selectedItem.organization?.institutionName ? '' : 'red' }">
								{{ selectedItem.organization?.institutionName ?? $t('unassigned') }}
							</div>
						</v-col>
						<v-col cols="4" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('asset-tag') }}:</div>
							<div class="text-body-1">{{ selectedItem.assetTag || '-' }}</div>
						</v-col>
						<v-col cols="8" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('hospital-name') }}:</div>
							<div class="text-body-1" :style="{ color: selectedItem.location?.hospitalName ? '' : 'red' }">
								{{ selectedItem.location?.hospitalName ?? $t('unassigned') }}
							</div>
						</v-col>
						<v-col cols="4" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('warranty-end-date') }}:</div>
							<div class="text-body-1">
								{{ selectedItem.warrantyEndDate ? formatTimestamp(selectedItem.warrantyEndDate) : '-' }}
							</div>
						</v-col>
						<v-col cols="8" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('purchase-price') }}:</div>
							<div class="text-body-1">{{ selectedItem.purchasePrice }} {{ selectedItem.purchaseCurrency }}</div>
						</v-col>
						<v-col cols="4" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('purchase-date') }}:</div>
							<div class="text-body-1">
								{{ selectedItem.purchaseDate ? formatTimestamp(selectedItem.purchaseDate) : '-' }}
							</div>
						</v-col>
						<v-col cols="8" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('shipment-cost') }}:</div>
							<div class="text-body-1">{{ selectedItem.shipmentCost }} {{ selectedItem.shipmentCurrency }}</div>
						</v-col>
						<v-col cols="4" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('shipment-date') }}:</div>
							<div class="text-body-1">
								{{ selectedItem.shipmentDate ? formatTimestamp(selectedItem.shipmentDate) : '-' }}
							</div>
						</v-col>
						<v-col cols="8" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('status') }}:</div>
							<div class="text-body-1">{{ getStatusText(selectedItem.status) }}</div>
						</v-col>
						<v-col cols="4" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('tracking-number') }}:</div>
							<div class="text-body-1">{{ selectedItem.trackingNumber || '-' }}</div>
						</v-col>
						<v-col cols="8" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('condition') }}:</div>
							<div class="text-body-1">{{ getConditionText(selectedItem.condition) }}</div>
						</v-col>
						<v-col cols="4" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('invoice-number') }}:</div>
							<div class="text-body-1">{{ selectedItem.invoiceNumber || '-' }}</div>
						</v-col>
						<v-col cols="12" class="text-left">
							<div class="text-subtitle-1 font-weight-bold">{{ $t('notes') }}:</div>
							<div class="text-body-1" style="white-space: pre-wrap">{{ selectedItem.note || '-' }}</div>
						</v-col>
					</v-row>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { formatTimestamp } from '@/utils/utilities';
import { mapActions, mapState } from 'vuex';
export default {
	name: 'ItemViewDialog',
	props: ['showDialog', 'selectedItem'],
	computed: {
		...mapState({
			itemStatusOptions: (state) => state.inventoryItems.itemStatusOptions,
			itemConditionOptions: (state) => state.inventoryItems.itemConditionOptions,
		}),
	},
	mounted () {
		if (!this.itemStatusOptions?.length) {
			this.getInventoryItemStatusOptions();
		}
		if (!this.itemConditionOptions?.length) {
			this.getInventoryItemConditionOptions();
		}
	},
	methods: {
		...mapActions({
			getInventoryItemStatusOptions: 'inventoryItems/getInventoryItemStatusOptions',
			getInventoryItemConditionOptions: 'inventoryItems/getInventoryItemConditionOptions',
		}),
		formatTimestamp,
		getStatusText (statusValue) {
			const statusOption = this.itemStatusOptions.find((option) => option.value === statusValue);
			return statusOption ? statusOption.description : statusValue;
		},
		getConditionText (conditionValue) {
			const conditionOption = this.itemConditionOptions.find((option) => option.value === conditionValue);
			return conditionOption ? conditionOption.description : conditionValue;
		},
	},
};
</script>
